import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { offerAgreementsAPI } from "api/api/offerAgreementsApi/offerAgreementsApi";
import { GetMarathonAgreementsByMarathonIdParams, GetMarathonAgreementsByMarathonIdRes } from "api/api/offerAgreementsApi/types";

export const getMarathonAgreementsByMarathonId = createAsyncThunk<
  GetMarathonAgreementsByMarathonIdRes,
  GetMarathonAgreementsByMarathonIdParams
>(
  "offerAgreements/getMarathonAgreementsByMarathonId",
  async ({ ...params }, { rejectWithValue }) => {
    try {
      const data = await offerAgreementsAPI.getMarathonAgreementsByMarathonId(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("AxioError while getting marathon agreements", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while getting marathon agreements", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  })